import React, { useState, useEffect } from 'react';
import { API_URL, fetchData } from '../helpers/api';
import usePageData from '../helpers/usePageData';
import '../css/decouvrir.css';

const DecouvrirMACTe = () => {
    const [heroVideo, setHeroVideo] = useState(null);
    const [videoLoading, setVideoLoading] = useState(true);
    const { data: pageData, loading: pageLoading } = usePageData('decouvrir');

    useEffect(() => {
        const fetchHeroVideo = async () => {
            try {
                const settingsData = await fetchData('/api/setting?populate=*');
                if (settingsData?.decouvrirVideo) {
                    setHeroVideo(API_URL + settingsData.decouvrirVideo.url);
                }
            } catch (error) {
                console.error('Failed to fetch hero video', error);
            } finally {
                setVideoLoading(false);
            }
        };

        fetchHeroVideo();
    }, []);

    if (videoLoading || pageLoading || !pageData) {
        return null;
    }

    return (
        <div className="decouvrir-macte">
            {/* Hero Section with Video */}
            <div className="home-hero position-relative vh-100 w-100 overflow-hidden pt-5">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                    style={{ zIndex: 0 }}
                >
                    <source src={heroVideo} type="video/mp4" />
                    <img
                        src="https://placehold.co/1920x1080"
                        alt="Mémorial ACTe"
                        className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                    />
                </video>

                <div className="position-absolute top-0 start-0 end-0 bottom-0 bg-dark z-index-1"></div>

                <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex flex-column justify-content-center align-items-center text-white z-index-2 px-4 text-center">
                    <h1 className="display-4 fw-bold mb-4 lh-sm" style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}>
                        {pageData.hero.title.includes('MACTe') ? (
                            <>{pageData.hero.title.split('MACTe')[0]}<span className="text-warning">MACTe</span>{pageData.hero.title.split('MACTe')[1]}</>
                        ) : pageData.hero.title}
                    </h1>

                    <p className="fs-4 mx-auto mb-4 fw-light" style={{ maxWidth: "800px" }}>
                        {pageData.hero.subtitle}
                    </p>
                </div>
            </div>

            {/* Content Sections */}
            <section className="py-5 bg-white">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            {pageData.sections.map((section, index) => (
                                <div key={index} className={index > 0 ? 'mt-5' : ''}>
                                    {section.title && (
                                        <h2 className="display-5 fw-bold mb-4">{section.title}</h2>
                                    )}
                                    {section.content && (
                                        <p className="fs-5 text-muted mb-4">{section.content}</p>
                                    )}
                                    {section.blockquote && (
                                        <blockquote className="blockquote bg-light p-4 rounded border-start border-warning border-4 mb-4">
                                            <p className="fst-italic">{section.blockquote}</p>
                                            {section.blockquoteAuthor && (
                                                <footer className="blockquote-footer">{section.blockquoteAuthor}</footer>
                                            )}
                                        </blockquote>
                                    )}
                                    {section.paragraphs && (
                                        <div className="fs-5 text-muted">
                                            {section.paragraphs.map((p, i) => (
                                                <p key={i}>{p}</p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DecouvrirMACTe;
